<template>
    <div/>
</template>

<script>
import PasswordChange from "./PasswordChange";
import { AUTH_ACTIONS } from "@/store/actions";

export default {
    name: 'PasswordManagement',
    components: {
    },
    props: {
        emailAddress: String,
    },
    data() {
        return {
            passwordNew: "",
            passwordConfirm: "",
            validated: false,
            isOpen: false,
            isConfirmPromptOpen: false,
            reset: () => {},
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.ShowDialog();
    },
    methods: {
        OnClose() {
            const self = this;

            self.$emit('Close');
        },
        OnSuccess() {
            const self = this;

            self.$emit('Success');
        },
        ShowDialog() {
            const self = this;
            
            self.CloseDialog();

            let onClickSave = (e) => {
                self.ClickSave();
            }

            let onClickClose = (e) => {
                self.CloseDialog();
            }

            self.$dialog.open({
                title: "Password Change",
                height: "auto",
                minHeight: 1,
                width: 350,
                resizable: false,
                draggable: false,
                okOnly: true,
                okTitle: "OK",
                closeOnEsc: true,
                hideHeaderClose: true,
                scrollable: false,
                component: PasswordChange,
                buttons: [
                    { title: "Cancel", automationId: "btn_dm_modal_cancel", cssClass: "btn btn-secondary", isVisible: true, closeOnComplete: false, onClick: onClickClose },
                    { title: "Ok", automationId: "btn_dm_modal_save", cssClass: "btn btn-primary", isVisible: true, closeOnComplete: false, onClick: onClickSave },
                ],
                onOpened: () => { self.isOpen = true },
                onCancel: onClickClose,
                onComponentAction(e) {
                    if (e.originalEvent.name == 'PasswordInformationChanged'){
                        // self.passwordNew = e.originalEvent.data.passwordNew;
                        // self.passwordConfirm = e.originalEvent.data.passwordConfirm;
                        // self.validated = e.originalEvent.data.validated;
                    }
                    if (e.originalEvent.name == 'Open'){
                        self.isOpen = true;
                        self.reset = e.originalEvent.action;
                    }
                    return false;
                }
            });
        },
        CloseDialog() {
            const self = this;

            if (self.isOpen){
                self.$dialog.close();
                self.isOpen = false;

                self.$emit('Close');
            }
        },
        ClickSave() {
            const self = this;

            // Make sure everything is valid.
            // if (!self.validated) {
            //     var message = "<div><p>Your password has not met all requirements. Please review.</div>"
            //     self.MessageBox("Invalid Input", message);
            //     return;
            // }

            // Must call save.
            self.ConfirmPrompt();
        },
        ConfirmPrompt() {
            const self = this;

            // self.$dialog.confirm("Confirm", "Are you sure you wish to update the login password?",
            //     () => {
            //         // OK HANDLER
                    self.$api.UserAccountApi.forcePasswordUpdateOnLogin(self.emailAddress)
                        .then((result) => {
                            self.CloseDialog();

                        // Force logout.
                            this.$store.dispatch(AUTH_ACTIONS.LOGOUT, { redirectUrl: window.location.origin });

                        }).catch((err) => {
                            
                        });
                // },
                // () => {
                //     // CANCEL HANDLER
                // });
        },
        MessageBox(title, message) {
            const self = this;

            self.$dialog.open({
                title: title,
                height: "auto",
                minHeight: 1,
                width: 350,
                resizable: false,
                draggable: false,
                okOnly: true,
                okTitle: "OK",
                closeOnEsc: true,
                hideHeaderClose: true,
                scrollable: false,
                component: {
                    name: "MessageBox",
                    template: '<div class="rq-message-box dialog-confirm-message" v-html="mbMessage"></div>',
                    data: function data() {
                        return { mbMessage: message };
                    }
                }
            });
        },
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>